export const getErrorByKey = (errors, key) => {
  if (!Array.isArray(errors)) return null;
  const find = errors.find((i) => i.key === key);
  return find?.messages?.join(' ');
};
